module.exports = __webpack_public_path__ + "media/images/preview_diary_3_thumb-d6f075427448aa53053b03f0580c051a.webp";